import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'ka',
  Pagination: {
    items_per_page: '/ გვერდი.',
    jump_to: 'გადასვლა',
    jump_to_confirm: 'დადასტურება',
    page: '',
    prev_page: 'წინა გვერდი',
    next_page: 'შემდეგი გვერდი',
    prev_5: 'წინა 5 გვერდი',
    next_5: 'შემდეგი 5 გვერდი',
    prev_3: 'წინა 3 გვერდი',
    next_3: 'შემდეგი 3 გვერდი',
  },
  DatePicker: {
    lang: {
      placeholder: 'აირჩიეთ თარიღი',
      yearPlaceholder: 'აირჩიეთ წელი',
      quarterPlaceholder: 'აირჩიეთ მეოთხედი',
      monthPlaceholder: 'აირჩიეთ თვე',
      weekPlaceholder: 'აირჩიეთ კვირა',
      rangePlaceholder: [
        'საწყისი თარიღი',
        'საბოლოო თარიღი',
      ],
      rangeYearPlaceholder: [
        'საწყისი წელი',
        'საბოლოო წელი',
      ],
      rangeMonthPlaceholder: [
        'საწყისი თვე',
        'საბოლოო თვე',
      ],
      rangeWeekPlaceholder: [
        'საწყისი კვირა',
        'საბოლოო კვირა',
      ],
      locale: 'ka_GE',
      today: 'დღეს',
      now: 'ახლა',
      backToToday: 'მიმდინარე თარიღი',
      ok: 'Ok',
      clear: 'გასუფთავება',
      month: 'თვე',
      year: 'წელი',
      timeSelect: 'დროის არჩევა',
      dateSelect: 'თარიღის არჩევა',
      weekSelect: 'კვირის არჩევა',
      monthSelect: 'თვის არჩევა',
      yearSelect: 'წლის არჩევა',
      decadeSelect: 'ათწლეულის არჩევა',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'წინა თვე (PageUp)',
      nextMonth: 'მომდევნო თვე (PageDown)',
      previousYear: 'წინა წელი (Control + left)',
      nextYear: 'მომდევნო წელი (Control + right)',
      previousDecade: 'წინა ათწლეული',
      nextDecade: 'მომდევნო ათწლეული',
      previousCentury: 'გასული საუკუნე',
      nextCentury: 'მომდევნო საუკუნე',
    },
    timePickerLocale: {
      placeholder: 'აირჩიეთ დრო',
      rangePlaceholder: [
        'საწყისი თარიღი',
        'საბოლოო თარიღი',
      ],
    },
  },
  TimePicker: {
    placeholder: 'აირჩიეთ დრო',
    rangePlaceholder: [
      'საწყისი თარიღი',
      'საბოლოო თარიღი',
    ],
  },
  Calendar: {
    lang: {
      placeholder: 'აირჩიეთ თარიღი',
      yearPlaceholder: 'აირჩიეთ წელი',
      quarterPlaceholder: 'აირჩიეთ მეოთხედი',
      monthPlaceholder: 'აირჩიეთ თვე',
      weekPlaceholder: 'აირჩიეთ კვირა',
      rangePlaceholder: [
        'საწყისი თარიღი',
        'საბოლოო თარიღი',
      ],
      rangeYearPlaceholder: [
        'საწყისი წელი',
        'საბოლოო წელი',
      ],
      rangeMonthPlaceholder: [
        'საწყისი თვე',
        'საბოლოო თვე',
      ],
      rangeWeekPlaceholder: [
        'საწყისი კვირა',
        'საბოლოო კვირა',
      ],
      locale: 'ka_GE',
      today: 'დღეს',
      now: 'ახლა',
      backToToday: 'მიმდინარე თარიღი',
      ok: 'Ok',
      clear: 'გასუფთავება',
      month: 'თვე',
      year: 'წელი',
      timeSelect: 'დროის არჩევა',
      dateSelect: 'თარიღის არჩევა',
      weekSelect: 'კვირის არჩევა',
      monthSelect: 'თვის არჩევა',
      yearSelect: 'წლის არჩევა',
      decadeSelect: 'ათწლეულის არჩევა',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'წინა თვე (PageUp)',
      nextMonth: 'მომდევნო თვე (PageDown)',
      previousYear: 'წინა წელი (Control + left)',
      nextYear: 'მომდევნო წელი (Control + right)',
      previousDecade: 'წინა ათწლეული',
      nextDecade: 'მომდევნო ათწლეული',
      previousCentury: 'გასული საუკუნე',
      nextCentury: 'მომდევნო საუკუნე',
    },
    timePickerLocale: {
      placeholder: 'აირჩიეთ დრო',
      rangePlaceholder: [
        'საწყისი თარიღი',
        'საბოლოო თარიღი',
      ],
    },
  },
  global: {
    placeholder: 'გთხოვთ აირჩიოთ',
  },
  Table: {
    filterTitle: 'ფილტრის მენიუ',
    filterConfirm: 'კარგი',
    filterReset: 'გასუფთავება',
    filterEmptyText: 'ფილტრები არაა',
    emptyText: 'ინფორმაცია არაა',
    selectAll: 'აირჩიეთ მიმდინარე გვერდი',
    selectInvert: 'შეაბრუნეთ მიმდინარე გვერდი',
    selectNone: 'მონაცემების გასუფთავება',
    selectionAll: 'ყველას მონიშვნა',
    sortTitle: 'დალაგება',
    expand: 'სტრიქონის გაშლა',
    collapse: 'სტრიქონის შეკუმშვა',
    triggerDesc: 'დაღმავალი დალაგება',
    triggerAsc: 'აღმავალი დალაგება',
    cancelSort: 'დალაგების გაუქმება',
  },
  Modal: {
    okText: 'კარგი',
    cancelText: 'გაუქმება',
    justOkText: 'ოკ',
  },
  Popconfirm: {
    okText: 'კარგი',
    cancelText: 'გაუქმება',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'მოძებნე აქ',
    itemUnit: 'ერთეული',
    itemsUnit: 'ერთეულები',
    remove: 'ამოშლა',
    selectCurrent: 'მიმდინარე გვერდის არჩევა',
    removeCurrent: 'მიმდინარე გვერდის ამოშლა',
    selectAll: 'ყველას მონიშვნა',
    removeAll: 'ყველას წაშლა',
    selectInvert: 'მიმდინარე გვერდის შებრუნება',
  },
  Upload: {
    uploading: 'იტვირთება...',
    removeFile: 'ფაილის ამოშლა',
    uploadError: 'ატვირთვის შეცდომა',
    previewFile: 'ფაილის გადახედვა',
    downloadFile: 'ფაილის ჩამოტვირთვა',
  },
  Empty: {
    description: 'ინფორმაცია არაა',
  },
  Icon: {
    icon: 'ხატულა',
  },
  Text: {
    edit: 'რედაქტირება',
    copy: 'ასლი',
    copied: 'ასლი აღებულია',
    expand: 'გაშლა',
  },
  PageHeader: {
    back: 'უკან',
  },
  Form: {
    optional: '(არასავალდებულო)',
    defaultValidateMessages: {
      default: 'ველის შემოწმების შეცდომა ${label}-ისთვის',
      required: 'გთხოვთ შეიყვანეთ ${label}',
      enum: '${label} უნდა იყოს ერთ-ერთი [${enum}]-დან',
      whitespace: '${label} არ შეიძლება იყოს ცარიელი სიმბოლო',
      date: {
        format: '${label} თარიღის ფორმატი არასწორია',
        parse: '${label} თარიღში კონვერტირება არ არის შესაძლებელი',
        invalid: '${label} არასწორი თარიღია',
      },
      types: {
        string: '${label} არ არის სწორი ${type}',
        method: '${label} არ არის სწორი ${type}',
        array: '${label} არ არის სწორი ${type}',
        object: '${label} არ არის სწორი ${type}',
        number: '${label} არ არის სწორი ${type}',
        date: '${label} არ არის სწორი ${type}',
        boolean: '${label} არ არის სწორი ${type}',
        integer: '${label} არ არის სწორი ${type}',
        float: '${label} არ არის სწორი ${type}',
        regexp: '${label} არ არის სწორი ${type}',
        email: '${label} არ არის სწორი ${type}',
        url: '${label} არ არის სწორი ${type}',
        hex: '${label} არ არის სწორი ${type}',
      },
      string: {
        len: '${label} უნდა იყოს ${len} სიმბოლო',
        min: '${label} უნდა იყოს სულ მცირე ${min} სიმბოლო',
        max: '${label} უნდა იყოს მაქსიმუმ ${max} სიმბოლო',
        range: '${label} უნდა იყოს ${min}-${max} სიმბოლოს შორის',
      },
      number: {
        len: '${label} უნდა იყოს ${len} ტოლი',
        min: '${label} უნდა იყოს მინუმიმ ${min}',
        max: '${label} უნდა იყოს მაქსიმუმ ${max}',
        range: '${label} უნდა იყოს ${min}-${max} შორის',
      },
      array: {
        len: 'უნდა იყოს ${len} ${label}',
        min: 'სულ მცირე ${min} ${label}',
        max: 'არაუმეტეს ${max} ${label}',
        range: '${label}-ის რაოდენობა უნდა იყოს ${min}-${max} შორის',
      },
      pattern: {
        mismatch: '${label} არ ერგება შაბლონს ${pattern}',
      },
    },
  },
  Image: {
    preview: 'გადახედვა',
  },
};

export default localeValues;
